<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Payroll Banks"
      text="Update payroll bank"
      class="mb-0"
      :loading="loading"
    >
      <form v-if="dialog && !loading">
        <v-container>
          <v-row no-gutters>
            <v-col cols="12">
              <v-autocomplete
                v-model="localPayrollBank.type" 
                v-validate="'required'"
                :error-messages="errors.collect('type')"    
                data-vv-name="type" 
                data-vv-as="type"
                label="Type"
                item-text="name"
                item-value="name"
                :items="types"
                outlined
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="localPayrollBank.name"
                v-validate="'required'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"                
                label="Name"
                outlined
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="localPayrollBank.shift_code"
                v-validate="`required|isExistingSwiftCode:${localPayrollBank.id}`"
                :error-messages="errors.collect('shift_code')"
                data-vv-name="shift_code"                
                data-vv-as="SWIFT code"                
                label="SWIFT Code"
                outlined
                @input="localPayrollBank.shift_code = localPayrollBank.shift_code.toUpperCase()"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="localPayrollBank.bank_code"
                label="Bank Code"
                outlined
                @input="localPayrollBank.bank_code = localPayrollBank.bank_code.toUpperCase()"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"          
          class="white--text mb-0"
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions> 
    </material-card>  
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      payrollBank: {
        type: Object,
        default: null,
      },
      payrollBanks: {
        type: Array,
        required: true,
      },
    },
    data () {
      return {
        dialog: null,
        progressing: false,
        localPayrollBank: null,
        loading: false,
        types: [
          'Commercial',
          'DFI',
          'Digital Bank',
          'E-Wallet',
          'Investment',
          'Islamic',
        ],
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return

        let scope = this
        this.loading = true
        this.localPayrollBank = { ...this.payrollBank }
        this.loading = false
        
        this.$validator.extend('isExistingSwiftCode', {
          getMessage (field, args) {
            return 'Existing SWIFT code found'
          },
          validate (value, [currentBankId]) {
            return !scope.payrollBanks.some(bank => {
              return bank.shift_code === value && String(bank.id) !== String(currentBankId)
            })
          },
        })
      },
    },
    methods: { 
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.payrollBanks().update(this.payrollBank.id, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })

                  this.dialog = false
                }
              })
              .catch((e) => {
                if (e.response.data.status) {
                  this.$snack({ 
                    color: 'error',
                    message: e.response.data.status,
                  })
                }
              })
              .then(() => {
                this.progressing = false
              })
          })
      },
      prepareFormData () {
        let data = { 
          name: this.localPayrollBank.name,
          shift_code: this.localPayrollBank.shift_code,
          bank_code: this.localPayrollBank.bank_code,
          type: this.localPayrollBank.type,
        }
        return data
      },
    },
  }
</script>
